import moment from "moment";
import i18n from "@/i18n";

export function formatAsIsoWeek(date: Date): string {
    return moment(date).locale(i18n.locale).format('GGGG[W]WW')
}